import React, { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";

const AVReactPlayer = (props) => {
    const playerRef = useRef(null);
    const [videoSize, setVideoSize] = useState({
        width: "90%",
        height: "auto",
    });

    const [videoUrl, setVideoUrl] = useState("");
    let videoWidth = "1000px"; // Default video width

    const screenWidth = window.innerWidth;
    if (screenWidth < 400) {
        // Mobile screen
        videoWidth = "320px";
    } else if (screenWidth < 768) {
        // Mobile screen
        videoWidth = "600px";
    } else if (screenWidth < 1024) {
        // Tablet screen
        videoWidth = "800px";
    }

    const handleReady = () => {
        const playerElement = playerRef.current.getInternalPlayer();
        const { videoHeight, videoWidth } = playerElement;
        if (videoHeight > 500) {
            const newWidth = (500 / videoHeight) * videoWidth;
            setVideoSize({ width: `${newWidth}px`, height: "500px" });
        } else {
            setVideoSize({ width: "90%", height: "auto" });
        }
    };

    const handleProgress = ({ playedSeconds }) => {
        /* props.onCurrentTimeChange(playedSeconds); */
    };

    const handleDuration = (duration) => {
        if (props.setPlayer) {
            props.setPlayer({
                ...props.playerSlice,
                duration: duration,
            });
            playerRef.current.seekTo(props.playerSlice.played);
        }
    };

    const isGif = props.videoUrl.endsWith(".gif");

    return (
        <div
            className="flex justify-center items-center h-full"
            style={{ maxHeight: "500px" }}
        >
            <div
                style={{
                    width: videoWidth,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxHeight: "500px",
                    overflow: "hidden",
                }}
            >
                {isGif ? (
                    <img
                        src={props.videoUrl}
                        alt="GIF Content"
                        style={{
                            width: "90%",
                            height: "auto",
                            maxHeight: "500px",
                        }}
                    />
                ) : (
                    <ReactPlayer
                        ref={playerRef}
                        url={props.videoUrl}
                        controls
                        width={videoSize.width}
                        height={videoSize.height}
                        onReady={handleReady}
                        onProgress={handleProgress}
                        onDuration={handleDuration}
                    />
                )}
            </div>
        </div>
    );
};

export default AVReactPlayer;
